import { MovieOffOutlineIcon } from './MovieOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 6E94BD0C-39BF-4D74-99BB-738062232A19
 * name movie-off-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-off-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateOffOutlineIcon = MovieOffOutlineIcon;
export default SlateOffOutlineIcon